import { useContext, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Sidebar from '../../components/features/RequestForm/Sidebar'
import Sections from '../../components/features/RequestForm/Sections'
import { RequestContext } from '../../contexts/request.context'
import { AppConfigContext } from '../../contexts/app-config.context'
import { RequestEquipmentContext } from '../../contexts/request-equipment.context'

import styles from './styles.module.scss'

const RequestFormPage = () => {
  const [value, setValue] = useState(0)

  const { isLightMode } = useContext(AppConfigContext)
  const { selectedRequest, setSelectedFrequencyGroup, setSelectedRequestLocation } = useContext(RequestContext)
  const { setEquipment } = useContext(RequestEquipmentContext)

  useEffect(() => {
    return () => {
      setEquipment(null)
      setSelectedFrequencyGroup(null)
      setSelectedRequestLocation(null)
    }
  }, [selectedRequest])

  return (
    <Box className={`${styles.exerciseRequestForm} main-container`}>
      <Sidebar setValue={setValue} isLightMode={isLightMode} />
      <Sections value={value} setValue={setValue} isLightMode={isLightMode} />
    </Box>
  )
}

export default RequestFormPage
